import { useSelector } from 'react-redux';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from 'layout/MainLayout/Sidebar/MenuList/NavGroup';
import menuItems from '../MenuItem';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    // Get menu
    const menuBasis = useSelector((state) => state.customization.menuBasis);
    const menuAccess = useSelector((state) => state.customization.menuAccess);
    const menuBadge = useSelector((state) => state.customization.menuBadge);

    const navItems = menuItems(menuBasis, menuAccess, menuBadge).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
